import React from 'react';
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FaqItemData } from '@/lib/faqData';

export const FaqItem: React.FC<{ item: FaqItemData; index: number }> = ({ item, index }) => {
    return (
        <AccordionItem value={`item-${index}`} className="border border-border rounded-lg bg-card px-2">
            <AccordionTrigger className="px-4 py-5 text-left text-lg font-medium hover:no-underline hover:text-primary transition-colors">
                {item.question}
            </AccordionTrigger>
            <AccordionContent className="px-4 pb-6 pt-0 text-muted-foreground leading-relaxed text-base">
                {item.answer}
            </AccordionContent>
        </AccordionItem>
    );
};
